<template>
  <div class="label-right">
    <labels
      :device-id="deviceId"
      :insects="insects"
      :default-label="defaultLabel"
      :show-label="showLabel"
      :insect-index="insectIndex"
      :cates="cates"
      @set-default="setDefault"
      @set-show-label="setShowLabel"
      @set-device="setDevice"
      @set-insect="setInsect"
      @remove="removeInsect"
      @edit-insect="editInsect"
    ></labels>
    <!-- <files
      :pictures="pictures"
      :actived="detail.id"
      @get-detail="getDetail"
    ></files> -->
  </div>
</template>

<script>
import Labels from './labels'
// import Files from './fileList'

export default {
  components: { Labels },
  props: {
    cates: {
      type: Array,
      default() {
        return []
      }
    },
    deviceId: Number,
    defaultLabel: Number,
    showLabel: Number,
    insects: Array,
    pictures: Array,
    detail: Object,
    insectIndex: Number
  },
  methods: {
    setDefault(id) {
      this.$emit('set-default', id)
    },
    setShowLabel(id) {
      this.$emit('set-show-label', id)
    },
    setDevice(id) {
      this.$emit('set-device', id)
    },
    getDetail(id) {
      this.$emit('get-detail', id)
    },
    setInsect(index) {
      this.$emit('set-insect', index)
    },
    removeInsect(index) {
      this.$emit('remove', index)
    },
    editInsect(index, item) {
      this.$emit('edit-insect', index, item)
    }
  }
}
</script>

<style lang="css" scoped>
.label-right {
  width: 228px;
  height: 100%;
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  user-select: none;
}
</style>
